import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Button from "components/base/Button";
import ModalPesquisarProdutos from "./ModalPesquisarProdutos";

interface BotaoPesquisarProdutosProps {
    disabled?: boolean;
    variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "outline-primary" | "outline-secondary";
    size?: "sm" | "lg";
    text?: string;
    className?: string;
}

const BotaoPesquisarProdutos: React.FC<BotaoPesquisarProdutosProps> = ({
    disabled = false,
    variant = "outline-primary",
    size,
    text = "Pesquisar",
    className = ""
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                className={className}
                onClick={() => setShowModal(true)}
                disabled={disabled}
            >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                {text}
            </Button>

            <ModalPesquisarProdutos
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    );
};

export default BotaoPesquisarProdutos; 